import React from 'react'
import { Grid, withStyles } from '@material-ui/core'
import styles from '../../styles'
import FormViewButtons from '../FormViewButtons'
import FormView from './FormView/'

export default withStyles(styles)(({ classes }) => (
	<Grid className={classes.main} container spacing={24}>
		<Grid item xs={12}>
			<Grid justify="center" container spacing={24}>
				<Grid item>
					<FormViewButtons />
				</Grid>
			</Grid>
		</Grid>
		<Grid item xs={12}>
			<FormView />
		</Grid>
	</Grid>
))
